<ion-button (click)="onClick()">
  <ion-icon
    ios="ellipsis-vertical"
    md="ellipsis-vertical"
    slot="icon-only"
  ></ion-icon>
</ion-button>
